import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { PlanService } from 'src/app/services/actions/plan.service';

@Component({
  selector: 'app-pagamentos',
  templateUrl: './pagamentos.component.html',
  styleUrls: ['./pagamentos.component.scss']
})
export class PagamentosComponent implements OnInit {

  @Input() paymentData: object;
  @Input() plan: object;
  @Input() paymentMethod: String;

  boletoUrl = false

  constructor(
    private router: Router,
    private planService: PlanService,
    private toastr: ToastrService
  ) { }

  ngOnInit () {
    if (this.plan['value'] === 0) {
      this.router.navigate(['/logado/plano'])
      this.toastr.success("Seu plano foi ativado!", "Sucesso")
    }
    if (this.paymentMethod === 'boleto') {
      this.getBoletoUrl()
    }
  }

  formatDate (dateInput) {
    return moment(dateInput).format('DD/MM/YYYY')
  }

  voltar () {
    window.history.back()
  }

  meuPlanos () {
    this.router.navigate(['/logado/plano'])
  }

  copyCode(code: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = code;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
		this.toastr.success('Código pix copiado!');
  }

  getBoletoUrl () {
    setTimeout(() => {
      this.planService
			.getBoletoUrl(this.paymentData['transaction']['id'])
			.subscribe(
				(res) => {
          if (res['boleto_url'] !== null) {
            this.boletoUrl = res['boleto_url']
          }
				},
				(err) => {
				}
			);
    }, 5000);
  }
}
